// ** React Imports
import { Navigate } from 'react-router-dom'
import { useContext, Suspense } from 'react'

// ** Context Imports
import { AbilityContext } from '@src/utility/context/Can'

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext)
  const user = JSON.parse(localStorage.getItem('userData'))

  if (route) {
    let action = null
    let resource = null
    let restrictedRoute = false
    let operatorRoute = false
    
    if (route.meta) {
      action = route.meta.action
      resource = route.meta.resource
      restrictedRoute = route.meta.restricted
      operatorRoute = route.meta.operatorRoute
    }

    // Handle operator routes
    if (operatorRoute) {
      if (!user) {
        return <Navigate to="/bus-operator-portal/login" />
      }
      if (user && user.roleType !== 'BUS_OPERATOR') {
        return <Navigate to="/misc/not-authorized" replace />
      }
      // The API refuses everything else until a one-time password is replaced.
      if (user.requiresPasswordReset && route.path !== '/bus-operator-portal/change-password') {
        return <Navigate to="/bus-operator-portal/change-password" replace />
      }
    } else {
      // Handle regular admin routes
      if (!user) {
        return <Navigate to="/login" />
      }
      if (user && user.roleType === 'BUS_OPERATOR') {
        return <Navigate to="/bus-operator-portal/dashboard" />
      }
    }

    if (user && restrictedRoute) {
      return <Navigate to="/" />
    }
    if (user && restrictedRoute && user.roleType === 'client') {
      return <Navigate to="/access-control" />
    }
    // Allow access to change-password route if user requires password reset
    if (user && user.requiresPasswordReset && route.path === '/user/change-password') {
      return <Suspense fallback={null}>{children}</Suspense>
    }
    if (user && !ability.can(action || 'read', resource)) {
      return <Navigate to="/misc/not-authorized" replace />
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>
}

export default PrivateRoute
